/* eslint-disable react/function-component-definition */
import React from 'react';

const MovieInformation = () => {
  return (
    <div>MovieInformation</div>
  );
};

export default MovieInformation;
